import { Trans } from "../utils/i18n";
import Cookies from "js-cookie";
import React from "react";
import MuiButton from "@material-ui/core/Button";
import {Inertia} from "@inertiajs/inertia";
import styled from "styled-components";
import { InertiaLink, } from "@inertiajs/inertia-react";

export const orderEntryConfigWorldpay = {
    "sizes": {
        "forth": 3,
        "third": 4,
        "half": 6,
        "full": 12
    },
    "heading": <Trans i18nKey="orderEntry.basicData">Basic data</Trans>,
    "groups": [
        {
            "fields": [
                {
                    "size": "full",
                    "component": "requesttypeselect"
                }
            ],
        },
        {
            "heading": <h2><Trans i18nKey="orderEntry.service">Service</Trans></h2>,
            "fields": [
                {
                    "name": "service",
                    "size": "half",
                    "titel": <Trans i18nKey="orderEntry.elient">Client</Trans>,
                    "type": "radiobig",
                    "value": "client",
                    "required": true,
                },
                {
                    "name": "service",
                    "size": "half",
                    "titel": <Trans i18nKey="orderEntry.engineer">Engineer</Trans>,
                    "type": "radiobig",
                    "value": "engineer",
                    "required": true,
                },
            ],
            "conditionFunction": values => {
                return values.requesttype == 'breakfix' || values.requesttype == 'fastTrack';
            }
        },
        {
            "heading": <h2><Trans i18nKey="orderEntry.service">Service</Trans></h2>,
            "fields": [
                {
                    "name": "service",
                    "size": "half",
                    "titel": <Trans i18nKey="orderEntry.elient">Client</Trans>,
                    "type": "radiobig",
                    "value": "client",
                    "required": true,
                },
            ],
            "conditionFunction": values => {
                return values.requesttype == 'wp360_breakfix' || values.requesttype == 'wp360_fastTrack' || values.requesttype == 'wp360_new' || values.requesttype == 'wp360_remove';
            }
        },
        {
            "heading": <h2><Trans i18nKey="orderEntry.productSelection">Product selection</Trans></h2>,
            "fields": [
                {
                    "size": "full",
                    "name": "productselectdynamic1",
                    "component": "productselectdynamic",
                    "mode": "serialnumber",
                    "conditionFunction": (values, orderEntryState) => !!values.requesttype && (values.requesttype == 'breakfix' || values.requesttype == 'wp360_breakfix' || values.requesttype == 'wp360_remove'),

                },
                {
                    "size": "full",
                    "name": "productselectdynamic2",
                    "component": "productselectdynamic",
                    "conditionFunction": (values, orderEntryState) => !!values.requesttype && (values.requesttype == 'fastTrack' || values.requesttype == 'wp360_fastTrack' || values.requesttype == 'wp360_new'),
                },
            ],
            "conditionFunction": values => {
                return ((values.requesttype == 'breakfix' || values.requesttype == 'fastTrack') && !!values.service) || ((values.requesttype == 'wp360_breakfix' || values.requesttype == 'wp360_fastTrack' || values.requesttype == 'wp360_remove' || values.requesttype == 'wp360_new') && values.service == 'client');
            }
        },
        {
            "heading": <h2><Trans i18nKey="orderEntry.problemDescription">Problem description</Trans></h2>,
            "fields": [
                {
                    "name": "problem_description",
                    "label": <Trans i18nKey="orderEntry.problemdescription.label">Problem description</Trans>,
                    "size": "full",
                    "type": "text",
                },
            ],
            "conditionFunction": (values, orderEntryState) => !!values.requesttype && (values.requesttype == 'breakfix' || values.requesttype == 'wp360_breakfix') && values.products?.every(product => product.amount),
        },

        {
            "heading": <h2><Trans i18nKey="orderEntry.addressContact">Address & contact information</Trans></h2>,
            "description": <Trans i18nKey="orderEntry.addressContact.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>,
            "fields": [
                {
                    "name": "name",
                    "label": <Trans i18nKey="orderEntry.addressContact.name">Name</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.name">Name</Trans>,
                    "size": "full",
                    "type": "text",
                    "required": true,
                },
                {
                    "name": "contact_name",
                    "label": <Trans i18nKey="orderEntry.addressContact.contact_name">Contact name</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.contact_name">Contact name</Trans>,
                    "size": "full",
                    "type": "text",
                },
                {
                    "name": "customer_number",
                    "label": <Trans i18nKey="orderEntry.addressContact.customernumber">Customer number</Trans>,
                    "size": "half",
                    "required": true,
                    "validatetype": "mid",
                },
                {
                    "name": "email",
                    "label": <Trans i18nKey="orderEntry.addressContact.email">E-Mail Address</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.email">E-Mail Address</Trans>,
                    "size": "half",
                    "type": "email",
                    "required": true,
                },
                {
                    "name": "phone",
                    "label": <Trans i18nKey="orderEntry.addressContact.phone">Phone</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.phoneNumber">Phone number</Trans>,
                    "size": "half",
                    "type": "phoneinput",
                    "required": true,
                },
                {
                    "name": "mobile",
                    "label": <Trans i18nKey="orderEntry.addressContact.mobile">Mobile</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.mobileNumber">Mobile number</Trans>,
                    "size": "half",
                    "type": "phoneinput",
                },
                {
                    "size": "full",
                    "component": "addressautocomplete"
                },
                {
                    "name": "zip",
                    "label": <Trans i18nKey="orderEntry.addressContact.zip">ZIP</Trans>,
                    "size": "half",
                    "required": true,
                    "validatetype": "api",
                    "validationRoute": route("order.validateZip"),
                },
                {
                    "name": "city",
                    "label": <Trans i18nKey="orderEntry.addressContact.city">City</Trans>,
                    "size": "half",
                    "required": true,
                },
                {
                    "name": "country_id",
                    "label": <Trans i18nKey="orderEntry.addressContact.country">Country</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.country.placeholder">Please choose</Trans>,
                    "size": "half",
                    "type": "select",
                    "options": [
                        {
                            "value": "de",
                            "label": <Trans i18nKey="orderEntry.addressContact.germany">Germany</Trans>
                        },
                        {
                            "value": "ch",
                            "label": <Trans i18nKey="orderEntry.addressContact.switzerland">Switzerland</Trans>
                        }
                    ],
                    "required": true,
                    "onlyCurrentCountry": false,
                },
            ],
            "conditionFunction": (values, orderEntryState) => !!values.requesttype && values.products?.every(product => product.amount),
        },
        {
            "heading": <h2><Trans i18nKey="orderEntry.notes.label">Notes</Trans></h2>,
            "description": <Trans i18nKey="orderEntry.notes.description"></Trans>,
            "fields": [
                {
                    "size": "full",
                    "key": "notes",
                    "name": "notes",
                    "label": <Trans i18nKey="queueDetail.notes.label">Notes</Trans>,
                    "multiline": true,
                },
            ],
            "conditionFunction": (values, orderEntryState) => !!values.requesttype && values.products?.every(product => product.amount),
        },
    ],
    "actions": [
        {
            "fields": [
                {
                    "text": <Trans i18nKey="orderEntry.send">Send</Trans>,
                    "size": "half",
                    "component": "button",
                    "action": "next",
                    "color": "secondary",
                    "conditionFunction": (values, orderEntryState) => {
                        const validAddress = values.name && values.customer_number && values.email && values.phone && values.city && values.housenumber && values.street && values.zip && values.country_id;

                        return !!values.requesttype && values.products?.every(product => product.amount) && validAddress;
                    }
                }
            ],
        },
    ],
    "success": function ({ response }) {

        const SuccessWrapper = styled.div`
            padding: 1rem 1rem;
            margin-left: 25%;
            margin-right: 25%;
            margin-top: 3rem;
            margin-bottom: 3rem;
            border-radius: .5rem;
            text-align: center;
            color: #000;
        `;

        return (
            <div>
                <h2 style={{ marginTop: 50 }} className={'text-center'}>
                    The order has been placed
                </h2>
                <SuccessWrapper className={'bg-blue-100'}>
                    <p>
                        Your reference number is:
                    </p>
                    <p>
                        <b>{ response?.order?.batch_reference }</b>
                    </p>
                </SuccessWrapper>
                <div className={'text-right'}>
                    <MuiButton
                        style={{ marginTop: 50}}
                        variant="contained"
                        color={"secondary"}
                        href={'/'}
                        component={InertiaLink}
                    >
                        <Trans i18nKey="common.home">
                            Home
                        </Trans>
                    </MuiButton>
                </div>
            </div>
        );
    }
}
